import { useEffect, useState } from "react";
import { disablePush, enablePush, isPushOn, pushSupport } from "../../utils/push";
import { toast } from "../../utils/toast";

// Footer of the bell panel: turn phone/browser notifications on or off for
// THIS device. Every bell notification is also pushed to subscribed devices.
export default function PushToggle() {
  const support = pushSupport();
  const [on, setOn] = useState(null); // null = still checking
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let alive = true;
    isPushOn().then((v) => alive && setOn(v)).catch(() => alive && setOn(false));
    return () => {
      alive = false;
    };
  }, []);

  const cls = "px-3 py-2 text-xs text-ink-muted border-t border-line";
  const btn = "font-medium text-brand-700 hover:text-brand-600 disabled:opacity-50";

  if (support === "unsupported") return null;
  if (support === "ios-install") {
    return (
      <p className={cls}>
        To get these on your iPhone, add this app to your Home Screen (Share → Add to Home Screen) and
        open it from there.
      </p>
    );
  }
  if (on === null) return null;
  if (!on && Notification.permission === "denied") {
    return <p className={cls}>Notifications are blocked for this site in your browser settings.</p>;
  }

  async function toggle() {
    setBusy(true);
    try {
      if (on) {
        await disablePush();
        setOn(false);
      } else {
        const permission = await enablePush();
        setOn(permission === "granted");
        if (permission === "granted") toast.success("Notifications are on for this device.");
      }
    } catch (err) {
      toast.error(err?.message || "Couldn't change notification settings.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className={`${cls} flex items-center justify-between gap-2`}>
      <span>{on ? "Notifications are on for this device." : "Get these as notifications on this device."}</span>
      <button type="button" onClick={toggle} disabled={busy} className={btn}>
        {on ? "Turn off" : "Turn on"}
      </button>
    </div>
  );
}
